// extracted by mini-css-extract-plugin
export default {"wrapper":"TrainerChatUserLayout_wrapper__SX76G","loader":"TrainerChatUserLayout_loader__PvEdz","placeholder":"TrainerChatUserLayout_placeholder__b7VpQ"};